import { render } from "./DeletePostComponent.vue?vue&type=template&id=98cfc424"
import script from "./DeletePostComponent.vue?vue&type=script&lang=js"
export * from "./DeletePostComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__